import { z } from 'zod';
import { PortfolioEventModelSchema } from 'entities/portfolio-event';
import { GetPortfolioEventByUidApiResponseSchema } from '../store';

export const createPortfolioEventFromGetPortfolioEventByUidApiResponse = (
    (response: z.infer< typeof GetPortfolioEventByUidApiResponseSchema>) => (
        PortfolioEventModelSchema.parse({
            uid: response.data.slug,
            name: response.data.name,
            description: response.data.description,
            images: response.data.images?.map(({ url }) => ({
                url,
            })),
            place: response.data.place,
            format: response.data.format,
            guestsCount: response.data.guestsCount,
            date: response.data.date && new Date(response.data.date),
            organizer: response.data.organizer,
            category: response.data.category && {
                name: response.data.category.name,
                uid: response.data.category.slug,
                slug: response.data.category.slug,
            },
            slug: response.data.slug,
        })
    )
);
